var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-bg-white s-px-3 s-py-5"
  }, [_c('header', {
    staticClass: "s-flex s-items-center s-mb-5 s-text-secondary"
  }, [_c('div', {
    staticClass: "s-icon s-mr-1"
  }, [_vm.icon === 'info' ? _c('svg', {
    attrs: {
      "width": "12",
      "height": "13",
      "viewBox": "0 0 12 13",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.46997 7.22998H9.53997",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.46997 9.54004H9.53997",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.47 0.5H0.5V12.5H11.47V0.5Z",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M9.42 1.97998H2.55C2.24624 1.97998 2 2.22622 2 2.52998V4.53998C2 4.84374 2.24624 5.08998 2.55 5.08998H9.42C9.72376 5.08998 9.97 4.84374 9.97 4.53998V2.52998C9.97 2.22622 9.72376 1.97998 9.42 1.97998Z",
      "fill": "currentColor"
    }
  })]) : _vm._e(), _vm.icon === 'list' ? _c('svg', {
    attrs: {
      "width": "12",
      "height": "13",
      "viewBox": "0 0 12 13",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.06006 3.16003H9.54006",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.49999 3.67002C2.78166 3.67002 3.00999 3.44169 3.00999 3.16002C3.00999 2.87836 2.78166 2.65002 2.49999 2.65002C2.21832 2.65002 1.98999 2.87836 1.98999 3.16002C1.98999 3.44169 2.21832 3.67002 2.49999 3.67002Z",
      "fill": "currentColor"
    }
  }), _c('path', {
    attrs: {
      "d": "M4.06006 6.34998H9.54006",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.49999 6.85997C2.78166 6.85997 3.00999 6.63163 3.00999 6.34997C3.00999 6.0683 2.78166 5.83997 2.49999 5.83997C2.21832 5.83997 1.98999 6.0683 1.98999 6.34997C1.98999 6.63163 2.21832 6.85997 2.49999 6.85997Z",
      "fill": "currentColor"
    }
  }), _c('path', {
    attrs: {
      "d": "M4.06006 9.54004H9.54006",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.49999 10.05C2.78166 10.05 3.00999 9.82169 3.00999 9.54003C3.00999 9.25836 2.78166 9.03003 2.49999 9.03003C2.21832 9.03003 1.98999 9.25836 1.98999 9.54003C1.98999 9.82169 2.21832 10.05 2.49999 10.05Z",
      "fill": "currentColor"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.47 0.5H0.5V12.5H11.47V0.5Z",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]) : _vm._e(), _vm.icon === 'currency' ? _c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 14 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M6.61001 10.5V10.17C6.02287 10.1395 5.45996 9.92621 5.00001 9.56002C4.87413 9.46549 4.7698 9.34528 4.69394 9.20735C4.61808 9.06942 4.57243 8.91694 4.56001 8.76002C4.55718 8.6936 4.56817 8.62732 4.5923 8.56538C4.61642 8.50343 4.65315 8.44718 4.70016 8.40017C4.74716 8.35317 4.80342 8.31644 4.86537 8.29231C4.92731 8.26818 4.99359 8.25719 5.06001 8.26002C5.24001 8.26002 5.37001 8.32002 5.60001 8.55002C5.77799 8.75766 5.99891 8.92421 6.24753 9.03816C6.49614 9.15211 6.76652 9.21074 7.04001 9.21002C7.78001 9.21002 8.20001 8.88002 8.20001 8.35002C8.20001 7.82002 7.91001 7.70002 7.20001 7.53002L6.26001 7.31002C5.21001 7.08002 4.66001 6.50002 4.66001 5.57002C4.66642 5.31524 4.72349 5.06429 4.82789 4.8318C4.93229 4.59931 5.08194 4.38992 5.2681 4.21587C5.45426 4.04181 5.67321 3.90655 5.91218 3.81798C6.15116 3.72942 6.40537 3.68932 6.66001 3.70002V3.33002C6.65519 3.27672 6.66232 3.22303 6.68086 3.17284C6.69941 3.12264 6.72892 3.07722 6.76723 3.03986C6.80554 3.00251 6.8517 2.97416 6.90235 2.95689C6.95299 2.93962 7.00685 2.93385 7.06001 2.94002C7.11316 2.93385 7.16702 2.93962 7.21766 2.95689C7.26831 2.97416 7.31447 3.00251 7.35278 3.03986C7.3911 3.07722 7.4206 3.12264 7.43915 3.17284C7.4577 3.22303 7.46482 3.27672 7.46001 3.33002V3.72002C7.99425 3.77066 8.50023 3.98351 8.91001 4.33002C9.14517 4.53349 9.29216 4.8203 9.32001 5.13002C9.32144 5.19036 9.31045 5.25035 9.28771 5.30626C9.26497 5.36216 9.23096 5.4128 9.18782 5.455C9.14467 5.49721 9.09331 5.53009 9.03691 5.5516C8.98052 5.5731 8.9203 5.58278 8.86001 5.58002C8.74752 5.57963 8.63665 5.55326 8.53604 5.50295C8.43543 5.45265 8.3478 5.37977 8.28001 5.29002C8.12946 5.0912 7.93425 4.93058 7.71016 4.82114C7.48606 4.7117 7.23937 4.6565 6.99001 4.66002C6.35001 4.66002 5.99001 5.01002 5.99001 5.48002C5.99001 5.95002 6.28001 6.15002 6.87001 6.28002L7.73001 6.50002C8.88001 6.75002 9.44001 7.31002 9.44001 8.24002C9.44001 9.17002 8.66001 10.04 7.44001 10.18V10.5C7.44913 10.5572 7.44574 10.6156 7.43008 10.6713C7.41443 10.727 7.38687 10.7786 7.34932 10.8227C7.31177 10.8667 7.26512 10.902 7.21258 10.9263C7.16004 10.9505 7.10287 10.9631 7.04501 10.9631C6.98714 10.9631 6.92997 10.9505 6.87743 10.9263C6.82489 10.902 6.77824 10.8667 6.74069 10.8227C6.70314 10.7786 6.67558 10.727 6.65993 10.6713C6.64427 10.6156 6.64089 10.5572 6.65001 10.5H6.61001Z",
      "fill": "currentColor"
    }
  })]) : _vm._e()]), _c('p', {
    staticClass: "s-text-sm s-font-semibold s-text-secondary"
  }, [_vm._v(_vm._s(_vm.title))])]), _c('main', [_vm._t("default")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }